import React from "react";
import "./TermsAndConditionsPromo.css"; 

const TermsAndConditionsPromo = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">
        📜 TERMO DE CONDIÇÕES DA PROMOÇÃO “CONECTADOS À MAGIA”
      </h1>

      <h2>1. OBJETO DA PROMOÇÃO</h2>
      <p>
        A promoção “Conectados à Magia” consiste em uma oferta especial válida
        <strong> de 01 de junho de 2025 a 30 de setembro de 2025</strong>,
        voltada exclusivamente para <strong>novos clientes </strong>da Sette
        Fibra, dentro da área de cobertura e conforme disponibilidade técnica
      </p>

      <h2>2. CONDIÇÕES COMERCIAIS</h2>
      <p>
        Durante o período promocional, os novos assinantes terão acesso ao{" "}
        <strong> plano de 1 GIGA (500 + 500 Mega) </strong> pelo{" "}
        <strong>
          {" "}
          valor promocional de R$ 99,90 (noventa e nove reais e noventa
          centavos)
        </strong>{" "}
        mensais,
        <strong>
          {" "}
          desde que o pagamento seja efetuado até a data do vencimento da
          fatura.
        </strong>
      </p>
      <ul>
        <li>
          O <strong> valor regular </strong> do plano é de{" "}
          <strong>
            {" "}
            R$ 129,90(cento e vinte e nove reais e noventa centavos)
          </strong>{" "}
          por mês.
        </li>
        <li>
          O valor promocional será aplicado{" "}
          <strong>
            {" "}
            exclusivamente para contratos firmados entre 01/06/2025 e
            30/09/2025.
          </strong>
        </li>
        <li>
          Após a adesão, o valor promocional será mantido durante o período de
          fidelidade, salvo em caso de inadimplemento.
        </li>
      </ul>

      <h2>3. STREAMING DISNEY+</h2>
      <p>
        O plano promocional inclui o acesso ao serviço de streaming{" "}
        <strong>
          {" "}
          Disney+ (com anúncios) gratuitamente por até 3 (três) meses
        </strong>
        , a contar da data de ativação do serviço.
      </p>
      <ul>
        <li>
          A gratuidade será proporcional ao mês de adesão, conforme abaixo:
          <br/>
          Exemplo: adesão em 01/06 = 90 dias de acesso; adesão em 15/09 = 16
          dias de acesso.
        </li>
        <li>
          Ao término do período gratuito, o acesso ao Disney+ será
          <strong> automaticamente suspenso.</strong>
        </li>
        <li>
          A continuidade do serviço será opcional, mediante
          <strong>
            {" "}
            contratação direta pelo cliente via portal do assinante.
          </strong>
          <br />
          <strong>Transparência:</strong> A Sette Fibra informará o cliente, de
          forma clara, sobre o término do período gratuito com antecedência
          mínima de 5 (cinco) dias.
        </li>
      </ul>

      <h2>4. INSTALAÇÃO</h2>
      <p>
        A instalação será <strong> gratuita para cadastros aprovados </strong>{" "}
        conforme critérios internos da Sette Fibra.
      </p>
      <ul>
        <li>
          Para cadastros <strong> não aprovados </strong> ou{" "}
          <strong> aprovados com ressalvas </strong>, poderá ser cobrada{" "}
          <strong> taxa de instalação</strong> , nos termos do plano
          convencional.
        </li>
        <li>
          O cliente será informado previamente sobre qualquer cobrança
          aplicável, de forma clara e destacada.
        </li>
      </ul>

      <h2>5. VIGÊNCIA E ENCERRAMENTO DA PROMOÇÃO</h2>
      <p>
        A promoção terá <strong> validade por 4 (quatro) meses </strong> , com{" "}
        <strong> início em 01/06/2025 e término em 30/09/2025</strong>
      </p>
      <ul>
        <li>
          Após essa data, a promoção será considerada encerrada, mesmo que
          materiais publicitários ainda estejam em circulação.
        </li>
        <li>
          Nestes casos, a oferta{" "}
          <strong> não estará mais disponível para contratação, </strong>
          prevalecendo os termos vigentes no momento do novo pedido.
        </li>
      </ul>

      <h2>6. FIDELIDADE CONTRATUAL</h2>
      <p>
        A adesão à promoção implica na celebração de contrato com{" "}
        <strong> período mínimo de fidelidade de 12 (doze) meses.</strong>
      </p>
      <ul>
        <li>
          Em caso de{" "}
          <strong> rescisão antecipada por iniciativa do cliente </strong>, será
          aplicada <strong> multa proporcional ao tempo restante </strong> de
          fidelidade, conforme contrato.
        </li>
        <li>
          A multa será{" "}
          <strong> devidamente informada no momento da contratação </strong> e
          nunca superior ao valor do benefício concedido.
        </li>
      </ul>
      <h2>7. CANCELAMENTO DO PLANO</h2>
      <p>
        O cliente poderá solicitar o cancelamento a qualquer momento, observadas
        as condições contratuais:
      </p>

      <ul>
        <li>
          <strong> Durante o período de fidelidade </strong>, será aplicada
          multa proporcional, nos termos da cláusula anterior.
        </li>
        <li>
          <strong> Após o término da fidelidade </strong>, o cancelamento poderá
          ser feito <strong> sem ônus </strong> , conforme os procedimentos
          legais e administrativos.
        </li>
      </ul>

      <h2>8. CONDIÇÕES GERAIS</h2>
      <ul>
        <li>
          A presente promoção é válida{" "}
          <strong> somente para novos contratos </strong> celebrados na área de
          cobertura da Sette Fibra,{" "}
          <strong> sujeita à viabilidade técnica. </strong>
        </li>
        <li>
          A Sette Fibra reserva-se o direito de{" "}
          <strong> alterar ou encerrar a promoção a qualquer momento </strong>,
          mediante comunicação prévia,{" "}
          <strong>
            {" "}
            respeitando os direitos adquiridos pelos consumidores que já
            contrataram no período promocional{" "}
          </strong>
          , nos termos do artigo 6º, III e V, do CDC.
        </li>
        <li>
          O consumidor será informado de forma{" "}
          <strong> clara, precisa e ostensiva </strong> sobre quaisquer
          alterações nas condições promocionais.
        </li>
      </ul>
    </div>
  );
};

export default TermsAndConditionsPromo;
